/*
  When I use SnippetJuggler, the component is owned by a Server Component, and there's no way to pass dynamic props through, to change the code.

  We expect this provider to wrap around SnippetJuggler, and to provide the correct code and language.
*/
import * as React from 'react';

import type { ContextValues } from './CodeSnippet.types';

export const CodeSnippetContext = React.createContext<ContextValues>({
  code: '',
  lang: '',
});

interface Props extends ContextValues {
  children: React.ReactNode;
}

function CodeSnippetProvider({ code, lang, children }: Props) {
  return (
    <CodeSnippetContext.Provider value={{ code, lang }}>
      {children}
    </CodeSnippetContext.Provider>
  );
}

export default React.memo(CodeSnippetProvider);
